import axios from 'axios';

axios.defaults.withCredentials = true;

const ensureResponse = (response, method, url) => {
  if (!response) {
    throw new Error(`Axios ${method.toUpperCase()} ${url} returned no response`);
  }

  return response;
};

export const getResponse = async (url, config) => ensureResponse(await axios.get(url, config), 'get', url);

export const postResponse = async (url, data, config) => ensureResponse(await axios.post(url, data, config), 'post', url);

export const putResponse = async (url, data, config) => ensureResponse(await axios.put(url, data, config), 'put', url);

export const patchResponse = async (url, data, config) => ensureResponse(await axios.patch(url, data, config), 'patch', url);

export const deleteResponse = async (url, config) => ensureResponse(await axios.delete(url, config), 'delete', url);

export const getData = async (url, config) => (await getResponse(url, config)).data;

export const postData = async (url, data, config) => (await postResponse(url, data, config)).data;

export const putData = async (url, data, config) => (await putResponse(url, data, config)).data;

export const patchData = async (url, data, config) => (await patchResponse(url, data, config)).data;

export const deleteData = async (url, config) => (await deleteResponse(url, config)).data;
